import { Dictionary } from '@feedyou/schema'

import { defaultSerializeQueryArgs } from './defaultSerializeQueryArgs'
import { SerializeQueryArgs } from '../../../types/rtkInternals'

export const customSerializers: Dictionary<string, SerializeQueryArgs<any>> = {
  getComments: params => 'getComments'
}

export const serializeQueryArgs: SerializeQueryArgs<any> = params => {
  const customSerializer = customSerializers[params.endpointName]

  if (customSerializer) {
    return customSerializer(params)
  }

  return defaultSerializeQueryArgs(params)
}
